import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Lock } from "../../../assets/img/icon/lock_black_24dp.svg";
import { ReactComponent as Visibility } from "../../../assets/img/icon/visibility_black_24dp.svg";
import { ReactComponent as VisibilityOff } from "../../../assets/img/icon/visibility_off_black_24dp.svg";
import respinos from "../../../assets/img/logo/Logo Respinos 3.png";
import { postPasswordVerification } from "../../../services/httpService/userRequest";
import { resetPasswordValidator } from "../../../validators/UserValidator";
import { GlobalContext } from "../../contexts/globalContext";
import Alert from "../../ui/atoms/Alert/Alert";
import Button from "../../ui/atoms/Button/Button";

const PasswordReset = (props) => {
  const [state, setState] = useState({
    key: "",
    token: "",
    isLoading: false,
    result: "",
    password: "",
    passwordHidden: true,
  });
  const [sharedState, dispatch] = useContext(GlobalContext);

  const handleTogglePassword = () => {
    setState((prevState) => ({
      ...prevState,
      passwordHidden: !prevState.passwordHidden,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
      result: "",
    }));
  };

  const generateErrorMessage = (error) => {
    let message;
    switch (error.message) {
      case "Network Error":
        message = `Error : Ada kesalahan jaringan. Silakan coba lagi.`;
        break;
      case "invalid key":
        message = `Error : Link tidak valid. Silakan periksa tautan verifikasi Anda.`;
        break;
      case "user hasn't verified yet":
        message = `Error : User belum melakukan verifikasi.`;
        break;
      default:
        message = error.message;
        break;
    }
    return message;
  };

  const handleChangePassword = async () => {
    try {
      const { error } = await resetPasswordValidator({
        password: state.password,
      });
      if (error) {
        dispatch("alert", {
          show: true,
          type: "warning",
          message: error.details[0].message,
        });
        return;
      }

      setState((prevState) => ({
        ...prevState,
        isLoading: true,
      }));

      await postPasswordVerification({
        key: state.key,
        password: state.password,
      });

      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        result: "Password telah diubah.",
      }));
    } catch (error) {
      const message = generateErrorMessage(error);
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        result: message,
      }));
    }
  };

  const handleParseUrl = async () => {
    const params = new URLSearchParams(props.location.search);
    setState((prevState) => ({
      ...prevState,
      email: params.get("email"),
      key: params.get("key"),
    }));
  };
  const hideAlert = () => {
    dispatch("alert", { show: false });
  };

  useEffect(() => {
    handleParseUrl();
  }, []);

  return (
    <div className="h-screen relative font-light bg-gradient-to-tr from-primary to-gray-100">
      <Alert data={sharedState.alert} handleClose={hideAlert} />
      <div className="h-full xl:container mx-auto px-2 sm:px-6 md:px-8 lg:px-10 pt-10 sm:pt-16 lg:pt-24 xl:pt-32">
        <div className="bg-white overflow-hidden rounded-xl shadow-xl w-4/5 sm:w-112 m-auto">
          <div className="px-4 py-3 sm:px-6 sm:py-6">
            <img src={respinos} alt="" className="mt-1 h-12 mx-auto" />

            <h1 className="mt-6 text-xl font-semibold text-center">
              Pemulihan Kata Sandi
            </h1>
            <div className="mt-3 text-sm md:text-base text-center">
              {state.result !== "" ? (
                state.result.includes("Error") ? (
                  <div>
                    <p>{state.result}</p>
                    <div className="mt-2">
                      Kembali ke{" "}
                      <Link to="/">
                        <span className="rounded-lg text-red-900 hover:text-opacity-70 underline mx-1">
                          Home
                        </span>
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p>{state.result}</p>
                    <div className="mt-2">
                      Klik{" "}
                      <Link to="/login">
                        <span className="rounded-lg text-red-900 hover:text-opacity-70 underline mx-1">
                          di sini
                        </span>
                      </Link>
                      untuk menuju ke halaman login.
                    </div>
                  </div>
                )
              ) : state.isLoading ? (
                <p>Processing request</p>
              ) : (
                <p>
                  Anda meminta pemulihan kata sandi untuk akun{" "}
                  <span className="text-red-700">
                    {state.email ? state.email : "-"}
                  </span>
                  . Silakan masukkan kata sandi baru di bawah ini.
                </p>
              )}
              <div>
                <div className="mt-2">
                  <div className="text-sm text-primary text-opacity-70 text-left">
                    Password
                  </div>
                  <div className="relative">
                    <Lock className="absolute top-1.5 left-2" fill="white" />
                    {state.passwordHidden ? (
                      <VisibilityOff
                        className="cursor-pointer absolute top-1.5 right-2"
                        fill="white"
                        onClick={handleTogglePassword}
                      />
                    ) : (
                      <Visibility
                        className="cursor-pointer absolute top-1.5 right-2"
                        fill="white"
                        onClick={handleTogglePassword}
                      />
                    )}
                    <input
                      type={state.passwordHidden ? "password" : "text"}
                      className={
                        "px-3 py-1.5 rounded-lg w-full text-white bg-secondary bg-opacity-70 pl-10 focus:outline-none focus:bg-opacity-90 "
                      }
                      name="password"
                      value={state.password}
                      onChange={handleChange}
                      disabled={state.isLoading}
                    />
                  </div>
                </div>
              </div>
            </div>

            <Button
              className="mt-5 w-full px-4 py-2 bg-gradient-to-tr from-dark-royale to-gray-900 rounded-xl text-white shadow-lg font-light text-sm md:text-base"
              handleClick={handleChangePassword}
            >
              Ubah Password
            </Button>

            <p className="mt-6 text-gray-900 text-opacity-80 text-xs md:text-sm bg-gray-200 px-2 py-1 rounded-lg">
              <span className="font-semibold">Catatan:</span> Jika Anda memiliki
              masalah reset kata sandi, silakan hubungi admin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
